import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DataService, OptionsserviceService, LoansService, OperationsService } from '../../_services/index';
import { CustomerService, StorageService } from '../../_services/index';

@Component({
  selector: 'app-customerreportedpayments',
  templateUrl: './customerreportedpayments.component.html',
  styleUrls: ['./customerreportedpayments.component.css']
})
export class CustomerreportedpaymentsComponent implements OnInit {

  @Input('request_id') request_id:any;
  loading : any;
  @Input('currentUser') currentUser:any;
  has_data = false; 
  repayments:any;
  constructor(public operationsService: OperationsService, public storageService: StorageService) { 

    //this.currentUser = this.storageService.read<any>('currentUser');
  }
 
  ngOnInit() {
    //this.getDueRepayments();
    if(this.currentUser){
      this.getCashFlowPerDate();
    }
    
   }
   getCashFlowPerDate(){
     this.loading = true;
     this.operationsService.getCustomerReportedPayments(this.currentUser.token,this.request_id)
       .subscribe(result => {
         this.loading = false;
         this.has_data = result.has_data;
         this.repayments = result.message; 
       });
   }

}
